export default "__VITE_ASSET__D66u8NKe__"